import { render, staticRenderFns } from "./szjz.vue?vue&type=template&id=bccf2a14&scoped=true&"
import script from "./szjz.vue?vue&type=script&lang=js&"
export * from "./szjz.vue?vue&type=script&lang=js&"
import style0 from "./szjz.vue?vue&type=style&index=0&id=bccf2a14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccf2a14",
  null
  
)

export default component.exports